import { SelfQuizPlatformStyles as styles } from "../css/styles";
import Flashcards from "../components/tasks/Flashcards";
import { MatchTask, QuestionTask, TwoInputsTask } from "../constants/AllTypes";
import { useLocation } from "react-router";
import Match from "../components/tasks/Match";
import OpenEnded from "../components/tasks/OpenEnded";

interface SelfQuizItem {
  selfQuizId: number;
  item: string;
  answer: string;
}

const createMatchTask = (items: SelfQuizItem[]): MatchTask => {
  return {
    taskId: "selfquiz-match",
    taskTitle: "Self Quiz Matching",
    taskType: "match",
    taskOrder: 0,
    taskContent: {
      pairs: items.map((i) => ({
        A: i.item,
        B: i.answer
      }))
    }
  };
};

const createFlashcardsTask = (items: SelfQuizItem[]): TwoInputsTask => {
  return {
    taskId: 'selfquiz-flashcards',
    taskTitle: 'Self Quiz Flashcards',
    taskType: 'flashcards',
    taskOrder: 0,
    taskContent: {
      items: items.map((i) => ({
        inputOne: i.item,
        inputTwo: i.answer,
        image: undefined
      }))
    }
  };
};

const createOpenEndedTask = (items: SelfQuizItem[]): QuestionTask => {
  return {
    taskId: "selfquiz-openended",
    taskTitle: "Self Quiz Open Ended",
    taskType: "openended",
    taskOrder: 0,
    taskContent: {
      questions: items.map((i) => ({
        question: i.item,
        answer: i.answer,
        image: undefined
      }))
    }
  };
};

const SelfQuizPlatform: React.FC = () => {
    const location = useLocation();
    const items = location.state?.items ?? [];
    const taskType: string = location.state?.taskType ?? "flashcards";

    let task: TwoInputsTask | MatchTask | QuestionTask | null = null;
    

   switch (taskType) {
    case "flashcards":
      task = createFlashcardsTask(items);
      break;
    case "match":
      task = createMatchTask(items);
      break;
    case "openended":
      task = createOpenEndedTask(items);
      break;

    default:
      task = null;
  }

  const renderTask = () => {
    if (!task) return null;

    switch (task.taskType) {
      case "flashcards":
        return <Flashcards task={task} isFullscreen />;

      case "match":
        return <Match task={task} isFullscreen />;

      case "openended":
        return <OpenEnded task={task} isFullscreen />;

      default:
        return null;
    }
  };

    return <div className={styles.platform}>{renderTask()}</div>;
    };

export default SelfQuizPlatform;